import { SupportedPaymentMethodsTag } from "consts/ecommerce";
import { useAppStore, useTypedSelector } from "hooks";
import type { CommaDelimitedString } from "types";
import { selectPaymentMethodsByProperty } from "features/paymentMethods/selectors";
import type { PaymentMethod } from "features/paymentMethods/types";
import type { Country } from "features/general/types";
import { selectCountriesByProperty } from "features/general/selectors";

export const useCountriesAvailable = (predefinedTags: Array<SupportedPaymentMethodsTag>) => {
    const store = useAppStore();
    const methods = useTypedSelector(selectPaymentMethodsByProperty('tag', predefinedTags));

    const getCountriesAvailable = (paymentMethodTag: SupportedPaymentMethodsTag): CommaDelimitedString => {
        const countries: Array<Country> = selectCountriesByProperty(
            'iso2',
            methods
                .filter(({ tag }: PaymentMethod) => (
                    Object.is(tag, paymentMethodTag)
                ))
                .map(({ forCountries }: PaymentMethod) => (
                    forCountries
                        .split(',')
                        .map(iso2 => iso2.trim())
                ))
                .flat()
        )(store.getState());

        return countries
            .map(({ shortName }) => shortName)
            .join(', ') || 'Worldwide';
    };

    return {
        getCountriesAvailable
    };
};

export default useCountriesAvailable;
